import script from "./InstructionPagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionPagerPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionPagerPage.vue?vue&type=style&index=0&id=dbfde0e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbfde0e8"]])

export default __exports__